import { render, staticRenderFns } from "./App.vue?vue&type=template&id=54df4466"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=54df4466&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports